import { Component, Inject, Injector, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { forkJoin } from "rxjs";
import { OrgLevelTypeEnum } from "src/app/enums/orgLevelType.enum";
import { Lookup } from "src/app/models/lookup.model";
import { OrganizationLevel } from "src/app/models/organizationLevel.model";
import { OrganizationLevelService } from "src/app/services/organizationLevel.service";
import { TypeService } from "src/app/services/type.service";
import {
    FormComponent,
    IFormDialogData,
} from "src/app/shared/form/form.component";
import {
    CheckboxFormField,
    SingleSelectionFormField,
    TextFormField,
} from "src/app/shared/form/formField.model";
import { ColumnSpan } from "src/app/shared/form/columnSpan.model";
import nameOf from "src/app/shared/form/nameOf.helper";

export interface IOrganizationLevelDialogData extends IFormDialogData {
    parentId?: string;
}

@Component({
  standalone: false,
    selector: "app-organization-level-dialog",
    templateUrl: "./../../shared/form/form.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./../../shared/form/form.component.scss"],
})
export class OrganizationLevelDialogComponent
    extends FormComponent<OrganizationLevel>
    implements OnInit
{
    organizationLevels: Lookup[];

    constructor(
        dialogRef: MatDialogRef<OrganizationLevelDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IOrganizationLevelDialogData,
        private organizationLevelService: OrganizationLevelService,
        private typeService: TypeService,
        protected injector: Injector,
    ) {
        super(
            dialogRef,
            organizationLevelService,
            data,
            "Organization",
            injector,
        );
    }

    ngOnInit(): void {
        this.isFormLoading = true;
        forkJoin({
            entity: this.getEntity(),
            organizationLevels: this.organizationLevelService.getAll(),
        }).subscribe(
            (result) => {
                this.entity = result.entity;
                this.organizationLevels = result.organizationLevels;
                this.initModel();
                this.initFields();
                this.isFormLoading = false;
            },
            (error) => {
                this.toastService.showError(error);
                this.isFormLoading = false;
            },
        );
    }

    getNewObject(): OrganizationLevel {
        return new OrganizationLevel();
    }

    validate(): boolean {
        return true;
    }

    initModel() {
        this.entity.parentId = this.data.parentId;
    }

    initFields(): void {
        this.fields = [
            new TextFormField({
                property: nameOf<OrganizationLevel>((x) => x.name),
                name: "Organization Name",
            }),
            new SingleSelectionFormField({
                property: nameOf<OrganizationLevel>((x) => x.orgLevelType),
                options: this.typeService.getEnumOptions(OrgLevelTypeEnum),
                name: "Organization Type",
            }),
            new SingleSelectionFormField({
                property: nameOf<OrganizationLevel>((x) => x.parentId),
                options: this.organizationLevels,
                name: "Parent Organization",
                required: false,
            }),
            new CheckboxFormField({
                property: nameOf<OrganizationLevel>(
                    (x) => x.enableLabResultExceedanceNotifications,
                ),
                name: "Enable Lab Result Exceedance Alerts",
                required: false,
                columnSpan: new ColumnSpan(1, 1),
                isVisible: () =>
                    this.entity.orgLevelType === OrgLevelTypeEnum.Site,
            }),
        ];
    }
}
